// import defaultState from './default';
import brand from './brand';
import { combineReducers } from 'redux';
import status from './auth/status';
import sms from './auth/sms';
import huggg from './huggg';
import hugggs from './hugggs';
import pin4 from './pin4';
import redeem from './redeem';
import tillo from './tillo';
import stash from './stash';
import voucher from './voucher';
import reaction from './reaction';
import prepaidCard from './prepaidCard';
import guidedChoice from './guidedChoice';
import selectedSegment from './selectedSegment';
import product from './product';

export default combineReducers({
  auth: combineReducers({ status, sms }),
  brand,
  huggg,
  hugggs,
  pin4,
  redeem,
  stash,
  tillo,
  voucher,
  reaction,
  guidedChoice,
  prepaidCard,
  selectedSegment,
  product
});
